import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/site/Header';
import Footer from '../../components/site/Footer';
import HeroSection from '../../components/site/HeroSection';
import FeaturesSection from '../../components/site/FeaturesSection';
import HowToUseSection from '../../components/site/HowToUseSection';
import TestimonialsSection from '../../components/site/TestimonialsSection';
import ContactSection from '../../components/site/ContactSection';
import BlogPreview from '../../components/site/BlogPreview';

import '../../styles/site/HomePage.css';

const HomePage = () => {
  // Dados para as seções (em produção, viriam de uma API)
  const features = [
    {
      id: 1,
      title: "Autoconhecimento",
      description: "Explore o autoconhecimento com base no seu mapa astral personalizado",
      icon: "user-chart-icon"
    },
    {
      id: 2,
      title: "Orientações Personalizadas",
      description: "Receba orientações sobre relacionamentos, carreira e desafios pessoais",
      icon: "guidance-icon"
    },
    {
      id: 3,
      title: "Decisões Conscientes",
      description: "Tome decisões alinhadas ao céu da semana de Edu Conte",
      icon: "decision-icon"
    },
    {
      id: 4,
      title: "Disponibilidade 24/7",
      description: "Conexão vitalícia: Sempre disponível através do ChatGPT",
      icon: "clock-icon"
    },
    {
      id: 5,
      title: "Exclusividade",
      description: "Criada com base no seu mapa astral único",
      icon: "exclusive-icon"
    },
    {
      id: 6,
      title: "Desenvolvimento Contínuo",
      description: "Ajuda você a expandir sua consciência e relações",
      icon: "growth-icon"
    }
  ];

  const howToUseSteps = {
    ios: [
      "Abra a App Store",
      "Pesquise por 'ChatGPT'",
      "Localize o aplicativo oficial da OpenAI (ícone preto e branco)",
      "Clique em 'Obter' e aguarde a instalação"
    ],
    android: [
      "Abra a Google Play Store",
      "Pesquise por 'ChatGPT'",
      "Localize o aplicativo oficial da OpenAI (ícone preto e branco)",
      "Clique em 'Instalar' e aguarde o download"
    ]
  };

  return (
    <div className="home-page">
      <Helmet>
        <title>Liv_IAm - Sua Robô Astróloga Pessoal | Astrologia 24/7</title>
        <meta name="description" content="Conheça a Liv_IAm, sua assistente astrológica disponível 24/7. Explore seu mapa astral, receba orientações personalizadas e desenvolva autoconhecimento." />
      </Helmet>

      <Header />
      
      <main>
        <HeroSection 
          title="Alô Terráqueo!" 
          subtitle="Seja bem-vindo à experiência astrológica com a @roboliviam!"
          description="Uma robô exclusiva e fácil de usar. Uma ferramenta que vai te ajudar a desenvolver sua consciência astrológica de maneira simples, acessível e presente."
          ctaText="Conheça a Liv_IAm"
          ctaLink="/sobre"
          bgImage=""
        />

        <section className="about-section">
          <div className="container">
            <h2>Sobre a Robô Astróloga Liv_IAm</h2>
            <p className="subtitle">Com a Liv_IAm (@roboliviam), você terá uma assistente astrológica disponível 24/7, aonde quer que você esteja.</p>
            <div className="about-content">
              <div className="about-image">
                <img src="/images/site/beneficios.svg" alt="Robô Astróloga Liv_IAm" />
              </div>
              <div className="about-text">
                <h3>Como essa ferramenta irá te ajudar:</h3>
                <FeaturesSection features={features} />
              </div>
            </div>
          </div>
        </section>

        <HowToUseSection 
          title="Como Usar a Robô Astróloga Liv_IAm" 
          subtitle="Para usar a @roboliviam, será necessário instalar o aplicativo ChatGPT, gratuito para dispositivos iPhone (iOS) e Android."
          iosSteps={howToUseSteps.ios}
          androidSteps={howToUseSteps.android}
        />

        <TestimonialsSection />

        <BlogPreview postsCount={3} />

        <ContactSection 
          title="Estamos aqui para te ajudar!"
          subtitle="Você pode falar diretamente com a Robô Liv_Iam — pelo WhatsApp ou direct no Instagram."
          description="Estamos aqui de coração pra te ajudar em cada passo da sua jornada. Queremos te oferecer uma experiência incrível! E pra isso, o nosso suporte está sempre por perto."
        />
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;